import React from 'react';

const OpportunityOverview: React.FC = () => {

  return (
    <div>Opportunity overview</div>   
  );
};

export default OpportunityOverview;
